import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import { CONTACT } from "@/lib/site";
import { LegalDialog } from "./LegalDialog";

export function Footer() {
  const [legal, setLegal] = useState(null);
  const year = new Date().getFullYear();
  return (
    <footer className="px-6 sm:px-10 pt-20 pb-10 bg-[#F5F7FA]" data-testid="site-footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-[rgba(20,35,55,0.10)]">
          <div className="md:col-span-5">
            <span className="font-display text-2xl font-bold tracking-[0.28em] text-[#0B1F3A]">FAD</span>
            <p className="mt-4 text-[15px] text-[#697386] leading-relaxed max-w-sm">
              Clear, goal-first briefings on Dubai real estate for Ethiopian and international investors.
            </p>
          </div>
          <ul className="md:col-span-4 space-y-3 text-[15px] text-[#172033]" data-testid="footer-contact">
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-[#0B1F3A] transition-colors" data-testid="footer-contact-email"><Mail size={16} className="text-[#C7A76C]" /> {CONTACT.email}</a></li>
            <li><a href={`https://wa.me/${CONTACT.whatsapp.replace("+", "")}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#0B1F3A] transition-colors" data-testid="footer-contact-whatsapp"><MessageCircle size={16} className="text-[#C7A76C]" /> {CONTACT.whatsappDisplay}</a></li>
            <li><a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.address)}`} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-[#0B1F3A] transition-colors" data-testid="footer-contact-address"><MapPin size={16} className="text-[#C7A76C] mt-0.5 shrink-0" /> {CONTACT.address}</a></li>
          </ul>
          <div className="md:col-span-3 flex flex-col items-start gap-3 text-[15px]">
            <button onClick={() => setLegal("privacy")} className="hover:text-[#0B1F3A] text-[#697386]" data-testid="footer-privacy-link">Privacy policy</button>
            <button onClick={() => setLegal("terms")} className="hover:text-[#0B1F3A] text-[#697386]" data-testid="footer-terms-link">Terms of use</button>
            <button onClick={() => setLegal("disclaimer")} className="hover:text-[#0B1F3A] text-[#697386]" data-testid="footer-disclaimer-link">Disclaimer</button>
          </div>
        </div>
        <p className="mt-8 text-xs text-[#697386] leading-relaxed max-w-3xl" data-testid="footer-disclaimer">
          Educational information only — not financial, legal, or tax advice. Property investments carry risk and returns are not guaranteed. USD figures are reference conversions and estimates; actual payment currency and exchange rates may differ.
        </p>
        <div className="mt-6 flex items-center justify-between text-xs text-[#697386]">
          <span>© {year} FAD — Firaol Amsalu Dessalegn</span>
          <Link to="/admin/login" className="opacity-40 hover:opacity-100 transition-opacity" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
      <LegalDialog kind={legal} onClose={() => setLegal(null)} />
    </footer>
  );
}
